import React, {ReactNode, Fragment, useState, useEffect} from 'react';

interface ClientOnlyProps {
  children: ReactNode;
  // consider adding `[index: string]: any;` and passing delegate props to div instead of Fragment
}

const ClientOnly = ({children}: ClientOnlyProps) => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return <Fragment>{children}</Fragment>;
};

export default ClientOnly;
